
import React, { useState } from "react";
import JobCard from "./Dashboard/Employee/JobCard";
import { FaChevronDown } from "react-icons/fa";
import JobDetails from "./Dashboard/Employee/JobDetails";
import logo from '../assets/Icons/QuesthireBlack.png'
import { Link } from "react-router-dom";
import EmailPopup from "./EmailPopup";

const jobData = [
  {
    title: "Warehouse Worker",
    company: "Martin Brower",
    location: "Oshawa, ON",
    method: "normal",
  },
  {
    title: "Entry Level Sales Representative",
    company: "American Income Life - Canada",
    location: "Toronto, ON",
    method: "quick",
  },
  {
    title: "Sr. Developers: Golang",
    company: "W3Global Inc",
    location: "Toronto, ON",
    method: "quick",
  },
  {
    title: "Sales Representative",
    company: "American Income Life - Canada",
    location: "Bradford, ON",
    method: "quick",
  },
  {
    title: "UI/UX Lead with Drupal Exp.",
    company: "W3Global Inc",
    location: "Toronto, ON",
    method: "quick",
  },
  {
    title: "Warehouse Free Sample Associate",
    company: "CDS (Club Demonstration Services)",
    location: "Toronto, ON",
    type: "Part-time",
    method: "quick",
  },
  {
    title: "Warehouse Free Sample Associate",
    company: "CDS (Club Demonstration Services)",
    location: "Newmarket, ON",
    type: "Part-time",
    method: "quick",
  },
  {
    title: "Cleaner / Custodian - Days",
    company: "Uline, Inc.",
    location: "Toronto, ON",
    type: "Full-time",
    method: "quick",
  },
];


const SearchResults = () => {
  const [search, setSearch] = useState("");
  const [selectedJob, setSelectedJob] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

const [showPopup, setShowPopup] = useState(true);

  const handleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  const filteredJobs = jobData.filter((job) =>
    `${job.title} ${job.company} ${job.location}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Top Header with Logo and Menu */}
      <header className="relative shadow-sm py-4 px-10 flex items-center justify-between z-20 bg-white">
        {/* Logo */}
        <div className="absolute left-10 top-1/2 -translate-y-1/2">
          <img src={logo} alt="logo" className="h-20 w-20 object-contain" />
        </div>
        <div className="w-64 flex-shrink-0"></div>
{showPopup && <EmailPopup onClose={() => setShowPopup(false)} />}

        {/* Navigation */}
        <div className="flex-1 flex justify-center gap-4 text-sm font-semibold">
          {[
            { name: "Job Seekers", items: ["Search Jobs", "Career Advice"] },
            { name: "Small & Medium Business", items: ["Post a Job", "Manage Listings"] },
            { name: "Enterprise Business", items: ["Solutions", "Request a Demo"] },
          ].map((menu) => (
            <div key={menu.name} className="relative group">
              <button
                onClick={() => handleDropdown(menu.name)}
                className="px-6 py-4 rounded hover:bg-gray-200 transition-colors flex items-center gap-2"
              >
                {menu.name}
                <FaChevronDown className="text-xs mt-1" />
              </button>
              {openDropdown === menu.name && (
                <div className="absolute left-0 mt-1 w-48 bg-white border rounded shadow-md z-10">
                  {menu.items.map((item) => (
                    <div key={item} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right Buttons */}
        <div className="flex-shrink-0 flex items-center gap-2">
          <Link
            to="/employer-onboarding"
            className="bg-white text-black px-4 py-2 rounded shadow border font-semibold hover:bg-gray-100 transition"
          >
            Post a Job
          </Link>
          <button className="px-4 py-2 border border-gray-400 rounded text-black font-semibold hover:bg-gray-100 transition">
            Login
          </button>
        </div>
      </header>

      {/* Search Input */}
      <div className="w-full px-10 py-4 border-b bg-white z-10 sticky top-[96px]"> {/* adjust top if needed */}
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search job titles, companies, or cities..."
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>

      {/* Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left: Job list */}
        <div className="w-[35%] border-r px-6 py-4 overflow-y-auto h-full">
          {filteredJobs.length === 0 ? (
            <p className="text-gray-500 mt-4">No jobs found.</p>
          ) : (
            <div className="space-y-4">
              {filteredJobs.map((job, idx) => (
                <div
                  key={idx}
                  onClick={() => setSelectedJob(job)}
                  className={`cursor-pointer ${selectedJob?.title === job.title ? "ring-2 ring-black" : ""
                    }`}
                >
                  <JobCard {...job} />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Right: Job details */}
        {selectedJob ? (
          <div className="w-[65%] overflow-y-auto h-full">
            <JobDetails job={selectedJob} onClose={() => setSelectedJob(null)} />
          </div>
        ) : (
          <div className="w-[65%] flex items-center justify-center text-gray-500">
            <p>Select a job to view details</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResults;
